export default __webpack_public_path__ + "static/media/48_desktop.a8a9df65.jpg";